import axios from "axios";

const BASE_URL = `${process.env.API_URL}/prompt-reason`;

export interface OpenAIBook {
  number: number;
  title: string;
  author: string;
  img: string;
}

export interface Category {
  category_name: string;
  books: OpenAIBook[];
}

export async function fetchReason(
  bookTitle: string,
  aiCategory: string,
  userCategory: string,
  categories: Category[]
): Promise<string | undefined> {
  console.log("hits fetch books");
  // Fetch the list of categories
  try {
    const { data } = await axios.post<{ reason: string }>(BASE_URL, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      data: {
        bookTitle,
        aiCategory,
        userCategory,
        categories,
      },
    });

    return data.reason;
  } catch (error) {
    console.log({ error });
  }
}
